import { useState } from "react"

import { prefetchPublicBoundlessConfigRetrieveQuery } from "@boundless/bl-api-client/public/services"
import { createFileRoute, redirect } from "@tanstack/react-router"

import { EmbedLoginDialog } from "@/embed/components/account/EmbedLoginDialog"
import { EmbedSignupDialog } from "@/embed/components/account/EmbedSignupDialog"
import { LandingPage } from "@/embed/components/landing-page/LandingPage"

type EmbedModal = "login" | "signup" | null

export const Route = createFileRoute("/embed/")({
  beforeLoad: ({ context: { store } }) => {
    if (store.getState().isAuthenticated) {
      throw redirect({ to: "/" })
    }
  },
  loader: async ({ context: { queryClient } }) => {
    return prefetchPublicBoundlessConfigRetrieveQuery(queryClient)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const [activeModal, setActiveModal] = useState<EmbedModal>(null)

  return (
    <>
      <LandingPage
        onGetStartedClick={() => {
          setActiveModal("signup")
        }}
        onSignInClick={() => {
          setActiveModal("login")
        }}
      />
      <EmbedLoginDialog
        open={activeModal === "login"}
        onOpenChange={(open) => {
          if (!open) {
            setActiveModal(null)
          }
        }}
        onSuccess={() => navigate({ to: "/" })}
      />
      <EmbedSignupDialog
        open={activeModal === "signup"}
        onOpenChange={(open) => {
          if (!open) {
            setActiveModal(null)
          }
        }}
        onSuccess={(email) => {
          setActiveModal(null)
          navigate({ to: "/embed/signup-complete", search: { email } })
        }}
        onSignInClick={() => {
          setActiveModal("login")
        }}
      />
    </>
  )
}
